import React from 'react';
import {
  getIn,
  FieldProps,
  ErrorMessage,
} from 'formik';

import {
  Flex,
} from 'web-styled';

import {
  Textarea,
  TextInput,
} from 'web-components';

import * as S from './styled';

export type InputProps = {
  flex: string;
  color: string;
  width?: string;
  height?: string;
  spacing?: number;
  margin?: string;
  placeholder?: string;
  textarea?: boolean,
  className?: string;
} & FieldProps;

const TextField = ({
  label,
  labelWeight,
  type,
  field,
  form,
  flex,
  width,
  color,
  margin,
  spacing,
  textarea,
  placeholder,
  className,
  ...props
}: InputProps) => {
  const error = getIn(form.errors, field.name);
  const touch = getIn(form.touched, field.name);
  const Component = textarea ? Textarea : TextInput;

  return (
    <Flex
      column
      flex={flex}
      width={width}
      margin={margin}
      spacing={spacing}
      className={className}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
          weight={labelWeight}
        >
          {label}
        </S.Label>
      )}
      <Component
        {...field}
        {...props}
        id={`${field.name}-id`}
        type={type}
        iserror={(touch && error)}
        placeholder={placeholder}
      />
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  );
};

export const TextFieldDefaultProps = {
  label: null,
  type: 'text',
  placeholder: '',
  spacing: 10,
  width: '100%',
  height: '',
  margin: '0',
  textarea: false,
};

TextField.defaultProps = TextFieldDefaultProps;

export default TextField;
